import { render, staticRenderFns } from "./medalTally.vue?vue&type=template&id=43fd9400&scoped=true"
import script from "./medalTally.vue?vue&type=script&lang=js"
export * from "./medalTally.vue?vue&type=script&lang=js"
import style0 from "./medalTally.vue?vue&type=style&index=0&id=43fd9400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fd9400",
  null
  
)

export default component.exports